import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectAsyncReducer } from 'io-redux/store';
import { reducers as deliveryReducers, actionCreators as deliveryActionCreators } from '../resource/deliveryrating';
import { translate } from '../../../common/translations';
injectAsyncReducer('DELIVERY_FEEDBACK_RATING', deliveryReducers("DELIVERY_FEEDBACK_RATING", ["UPDATE"]));

class DeliveryDetailsRatingForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			driverRate: props.delivery.customerRating || '',
			hoverDriverRate: props.delivery.customerRating || '',
			editable: !(props.delivery.customerRating > 0),
			isSubmitting: false,
			errorMessage: '',
			successMessage: '',
		}

	}

	submitRating(n, e) {
		e.preventDefault();
		if (!this.state.isSubmitting && this.state.editable) {
			this.setState({ isSubmitting: true, hoverDriverRate: n });
			const options = {
				clientId: this.props.deliveryConfig.clientId,
				postcode: this.props.delivery.postcode,
				rating: { score: n },
				url: window.location.href,
			};
			this.props.crudActions.update(
				encodeURIComponent(this.props.delivery.clientDeliveryIdentifier),
				options,
				null,
			);
			this.setState({ driverRate: n, errorMessage: '', successMessage: '', isSubmitting: true })
		}
	}

	handleOut() {
		if (!this.state.isSubmitting && this.state.editable) {
			this.setState({ hoverDriverRate: this.state.driverRate });
		}
	}

	handleHover(n, e) {
		if (!this.state.isSubmitting && this.state.editable) {
			this.setState({ hoverDriverRate: n });
		}
	}

	componentWillReceiveProps(newProps, newState) {
		if (newProps.itemAction.error !== null) {
			this.setState({ editable: true, isSubmitting: false, errorMessage: translate(newProps, 'Unable to save rating'), successMessage: '' });
			return;
		}
		if (newProps.itemAction.hasUpdated === true) {
			this.setState({ editable: false, isSubmitting: false, errorMessage: '', successMessage: translate(newProps, 'Thank you for your feedback.') });
			return;
		}
	}

	render() {
		const props = this.props;
		const styles = props.deliveryConfig.clientStyles;
		return (<div key="ratingForm" className="row division">
			<div className="col-12 text-center">
				<h3>{translate(props.lang, 'Rate This Delivery')}</h3>
				<p className="ratingStars" onMouseOut={this.handleOut.bind(this)}> {[1, 2, 3, 4, 5].map(i =>
					<a
						key={'ratingOption' + i}
						onClick={this.submitRating.bind(this, i)}
						onMouseOver={this.handleHover.bind(this, i)}
						className={((this.state.driverRate >= i && this.state.editable == false) || (this.state.hoverDriverRate >= i && this.state.editable == true) ? 'active' : 'inactive')}
					><svg style={(this.state.driverRate >= i && this.state.editable == false) || (this.state.hoverDriverRate >= i && this.state.editable == true) ? styles.ratingHighlight : styles.rating} x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
							<polygon strokeWidth="37.6152" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
                   259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08
                   29.274,197.007 188.165,173.919 "/>
						</svg></a>
				)}
				</p>
				{this.state.errorMessage ? <p>{this.state.errorMessage}</p> : null}
				{this.state.successMessage ? <p>{this.state.successMessage}</p> : null}
			</div>
		</div>);
	}
}

DeliveryDetailsRatingForm.contextTypes = {

};

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		searchParams: state.searchParams,
		searchValue: state.searchValue,
		item: state.DELIVERY_FEEDBACK_RATING === undefined || state.DELIVERY_FEEDBACK_RATING.item === undefined ? null : state.DELIVERY_FEEDBACK_RATING.item,
		itemAction: state.DELIVERY_FEEDBACK_RATING === undefined ? null : state.DELIVERY_FEEDBACK_RATING,
	}
};

const mapDispatchToProps = (dispatch) => ({
	crudActions: bindActionCreators(deliveryActionCreators("DELIVERY_FEEDBACK_RATING"), dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetailsRatingForm);
